import { ClampDimension } from 'app/modules/wallforming/components/scenes/objects/dimensions/ClampDimension';
import { PanelDimension } from 'app/modules/wallforming/components/scenes/objects/dimensions/PanelDimension';

import type { Vector3 } from 'three';

interface PlacementDimensionsProps {
    mid: Vector3;
    floorZ: number;
    selectedPoiIndex: number;
}

export const PlacementDimensions = ({ mid, floorZ, selectedPoiIndex }: PlacementDimensionsProps) => {
    return (
        <group key={selectedPoiIndex}>
            <PanelDimension floorZ={floorZ} mid={mid} selectedPoiIndex={selectedPoiIndex} />
            <ClampDimension floorZ={floorZ} mid={mid} selectedPoiIndex={selectedPoiIndex} />
        </group>
    );
};
